var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"vx-row mb-4"},[_c('div',{staticClass:"w-full md:w-1/3 vx-col"},[_c('radial-chart',{attrs:{"item":item}})],1),_c('div',{staticClass:"w-full md:w-2/3 vx-col"},[_c('bar-chart',{attrs:{"item":item}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }